import ContainerWrap from './container-wrap';

export default ContainerWrap;
